// extracted by mini-css-extract-plugin
var _1 = "ThreadVersionChangeCard-module__animateUploadProgressBarWidth--GE233";
var _2 = "ThreadVersionChangeCard-module__animatedBackground--o4pf_";
var _3 = "ThreadVersionChangeCard-module__contextContainer--tQIZI";
var _4 = "ThreadVersionChangeCard-module__footer--FkXls";
var _5 = "ThreadVersionChangeCard-module__footerText--wf4yY";
var _6 = "ThreadVersionChangeCard-module__footerTextContainer--ItEvN";
var _7 = "ThreadVersionChangeCard-module__hasAbsoluteEndQuote--m5CTZ";
var _8 = "ThreadVersionChangeCard-module__newCommentsText--xGli4";
var _9 = "ThreadVersionChangeCard-module__unresolveButton--Y6nnK";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "contextContainer", _4 as "footer", _5 as "footerText", _6 as "footerTextContainer", _7 as "hasAbsoluteEndQuote", _8 as "newCommentsText", _9 as "unresolveButton" }
